import React from "react";

const ContactChannelsChart = ({
  telephone = 0,
  line = 0,
  fb = 0,
  email = 0,
  app = 0,
}) => {
  const channels = [
    {
      name: "ช่องทางโทรศัพท์",
      count: telephone,
      color: "bg-green-500",
    },
    {
      name: "ช่องทาง Line",
      count: line,
      color: "bg-green-400 ",
    },
    {
      name: "ช่องทาง FB MSG",
      count: fb,
      color: "bg-blue-500",
    },
    {
      name: "ช่องทางอีเมล",
      count: email,
      color: "bg-yellow-400",
    },
    {
      name: "ช่องทางแอพพลิเคชั่น",
      count: app,
      color: "bg-pink-400",
    },
  ];

  return (
    <div className="bg-white shadow-lg rounded-lg p-4 flex justify-around gap-4">
      {/* Left Side Details */}
      <div>
        <h2 className="text-2xl font-bold mb-2">ช่องทางติดต่อ</h2>
        <ul className="space-y-2">
          {channels.map((channel) => {
            return (
              <li>
                <div className="flex items-center gap-2">
                  <div className={`h-3 w-3 ${channel.color} rounded-full`} />
                  <p>{channel.name}</p>
                </div>
                <p className="ml-auto text-xl font-bold">
                  {channel.count} รายการ
                </p>
              </li>
            );
          })}
        </ul>
      </div>

      {/* Right Side Chart */}

      <div className="w-52 h-52">
        <img
          src="/images/docs/channel.png"
          alt="Avatar"
          className="rounded-full"
        />
      </div>
    </div>
  );
};

export default ContactChannelsChart;
